import { render, staticRenderFns } from "./SetUser.vue?vue&type=template&id=ce4c4066&scoped=true"
import script from "./SetUser.vue?vue&type=script&lang=js"
export * from "./SetUser.vue?vue&type=script&lang=js"
import style0 from "./SetUser.vue?vue&type=style&index=0&id=ce4c4066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4c4066",
  null
  
)

export default component.exports